const getDateTimeformat = (date = new Date(), displayFormat = {}, locale = "en-IN") => {
    return (new Date(date).toLocaleDateString(locale, {...displayFormat}));
};

export default getDateTimeformat;
